import { render } from "./ModalIdiomas.vue?vue&type=template&id=1f539083&scoped=true"
import script from "./ModalIdiomas.vue?vue&type=script&lang=js"
export * from "./ModalIdiomas.vue?vue&type=script&lang=js"

import "./ModalIdiomas.vue?vue&type=style&index=0&id=1f539083&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f539083"

export default script